import { wrapperProps } from "./types/wrapperProps";

var styling: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    width: '100%'
}

const Wrapper = (props: wrapperProps) => {
    return (<div className={props.className} style={props.style !== undefined || props.className !== undefined ? props.style : styling}>{props.children}</div>)
}

export default Wrapper;